<template>
  <div>
    <MobileHeader />
    <MobileDirection />
    <MobileCertifi />
    <MobileAchievements />
    <!-- <MobileTeam /> -->
    <MobileExpert />
    <MobileCooper />

  </div>
</template>

<script>
import MobileHeader from './MobileHeader.vue' // 极客邦双数研究院极客邦双数研究院
import MobileDirection from './MobileDirection.vue' // 双数研究院 三大重点工作方向
import MobileCertifi from './MobileCertifi.vue' // 工业和信息化重点领域数字化转型 产业人才
import MobileAchievements from './MobileAchievements.vue' // 研究成果
// import MobileTeam from './MobileTeam.vue' // 院长及团队
import MobileExpert from './MobileExpert.vue' // 特聘专家
import MobileCooper from './MobileCoop.vue' // 合作机构
export default {
  name: '',
  components: {
    MobileHeader,
    MobileDirection,
    MobileCertifi,
    MobileAchievements,
    // MobileTeam,
    MobileExpert,
    MobileCooper
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {

  }
}
</script>
<style lang='scss' module>
</style>
